import CardContentCarousel from "./card-content-carousel";

export { CardContentCarousel };
